import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PatientAddEditPage } from './patient-add-edit';
import { MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule, MatAutocompleteModule, MatProgressSpinnerModule, MatIconModule, MatDatepickerModule, MatProgressBarModule, MatRadioModule } from '@angular/material';

@NgModule({
  declarations: [
    PatientAddEditPage,
  ],
  imports: [
    IonicPageModule.forChild(PatientAddEditPage),
    MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule, MatAutocompleteModule, MatProgressSpinnerModule, MatIconModule, MatDatepickerModule, MatProgressBarModule, MatRadioModule
  ],
})
export class PatientAddEditPageModule {}



// WEBPACK FOOTER //
// ./src/pages/patient-add-edit/patient-add-edit.module.ts